import { jsx as _jsx } from "react/jsx-runtime";
import { PAGINAS, ROUTES, FUNCIONALIDADES } from '../../../routes';
import { getTiposEmpresas } from '../../../api';
import GridBase from '../../../components/grid_base';
import StatusPesquisar from '../../../components/status_pesquisar';
var COLUNAS_FUNCIONALIDADE = [
    { field: 'nome', headerName: 'Nome', width: 650 },
    { field: 'situacao', headerName: 'Situação', width: 150 },
];
export default function TiposEmpresas() {
    return (_jsx(GridBase, { pagina: PAGINAS.CC_TIPOS_EMPRESAS, paginaPermissao: FUNCIONALIDADES.CC_TIPOS_EMPRESAS, rota: ROUTES.CC_TIPOS_EMPRESAS, columns: COLUNAS_FUNCIONALIDADE, filtrosIniciais: { situacao: '-1' }, fetchData: function (busca, filtros, paginacao) { return getTiposEmpresas(busca, filtros.situacao === '-1' ? null : filtros.situacao, paginacao); }, renderFiltros: function (filtros, atualizar) { return (_jsx(StatusPesquisar, { StatusPesquisa: filtros.situacao, filtrarGrid: function (_, novaSituacao) {
                atualizar({ situacao: novaSituacao });
            } })); } }));
}
